import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


import CropSelection from "./CropSelection/CropSelection";

import {labelCropStepper} from "./LabelCropStepper";
import CropYieldGoal from "./CropYieldGoal/CropYieldGoal";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import BeagleBuildCard from "../BeagleBuild/BeagleBuildCard";


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    buttonVerticalSpacer: {
        marginTop: theme.spacing(5),
    },
    alignItemsAndJustifyContent: {
        // width: 500,
        // height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }, rootNewCalc: {
        minWidth: 275,
        maxWidth: 325,
        backgroundColor: 'silver',
    },
}));


function getSteps(langPref) {

    return [
        labelCropStepper.labelChooseCrop[langPref],
        labelCropStepper.labelYieldGoal[langPref],
        labelCropStepper.labelViewResult[langPref]
    ]
}


function getStepContent(beagleLanguagePreference,
                        beagleMathPreference,
                        stepIndex,
                        beagleCropDatabase,
                        wizardCropKey,
                        switchWizardCropKey,
                        wizardYieldGoal,
                        switchWizardYieldGoal,
                        switchWizardCropCalculation,
                        handleNext,
                        beagleStyles) {

    // console.log('------getStepContent---- ' + stepIndex);

    switch (stepIndex) {


        //STEP: Select a crop.
        case 0:
            return <CropSelection
                beagleLanguagePreference={beagleLanguagePreference}
                beagleCropCatalog={beagleCropDatabase.crops}
                wizardCropKey={wizardCropKey}
                switchWizardCropKey={switchWizardCropKey.bind(this)}
            />


        //STEP: Enter the Yield Goal number.
        case 1:
            let cropDefinition = beagleCropDatabase.crops.find(record => record.cropKey === wizardCropKey);
            // console.log(cropDefinition);

            return <CropYieldGoal
                beagleLanguagePreference={beagleLanguagePreference}
                beagleMathPreference={beagleMathPreference}
                cropDefinition={cropDefinition}
                wizardYieldGoal={wizardYieldGoal}
                switchWizardYieldGoal={switchWizardYieldGoal.bind(this)}
                handleNext={handleNext.bind(this)}
            />


        //STEP: Done.

        // return <Grid item xs={12} md={12} lg={12} className={classesGrid.alignItemsAndJustifyContent}>
        //     <Card className={classesGrid.rootNewCalc}>

        case 2:
            return <Grid item xs={12} md={12} lg={12} className={beagleStyles.alignItemsAndJustifyContent}>
                <Card className={beagleStyles.rootNewCalc}>
                    <CardContent>
                        <BeagleBuildCard
                            beagleLanguagePreference={beagleLanguagePreference}
                            beagleMathPreference={beagleMathPreference}
                            wizardCropKey={wizardCropKey}
                            wizardYieldGoal={wizardYieldGoal}
                            switchWizardCropCalculation={switchWizardCropCalculation}
                        />
                    </CardContent>
                </Card>
            </Grid>


        default:
            return 'Unknown stepIndex';
    }
}


// const demoLoadDatabase = async event => {
//
//     const url = 'http://localhost:5000/nrc/toc/v1';
//
//     try {
//         const response = await fetch(url, {
//             method: 'GET',
//             headers: {
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify({
//                 blah: 'hello',
//                 echo: nodeExpressSalt
//             })
//         });
//
//         const responseData = await response.json();
//         console.log(responseData);
//
//     } catch (err) {
//         console.log(err);
//     }
//
//     //code here, will run once the above is complete.
//
// }


export default function CropStepper(props) {

    const langPref = props.beagleLanguagePreference;

    //The entire catalog.  This does not change.
    const beagleCropDatabase = props.awsCropDatabase;

    //The single crop selected.
    const [wizardCropKey, setWizardCropKey] = React.useState('');
    const switchWizardCropKey = (newCropKey) => {
        setWizardCropKey(newCropKey);
        // console.log('===== setWizardCropKey = ' + newCropKey);
    };

    //Yield Goal
    const [wizardYieldGoal, setWizardYieldGoal] = React.useState('');
    const switchWizardYieldGoal = (newYieldGoal) => {
        setWizardYieldGoal(newYieldGoal);
        // console.log('===== setWizardYieldGoal = ' + newYieldGoal);
    };

    //Holds the crop calculation.  It's save to history only on the final button.
    const [wizardCropCalculation, setWizardCropCalculation] = React.useState({});

    const switchWizardCropCalculation = (newBeagleCropCalculation) => {
        setWizardCropCalculation(newBeagleCropCalculation)
    }


    //*** Steps
    const beagleStyles = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps(langPref);

    const handleNext = () => {

        // console.log('---handleNext (top): wizardCropKey=' + wizardCropKey + " activeStep=" + activeStep);


        //CROP - check for a crop.
        if (wizardCropKey === '') {
            setActiveStep(0);
            return;
        }

        //YIELD GOAL - check for number.
        if (Number.isNaN(Number(wizardYieldGoal))) {
            setActiveStep(1);
            return;
        }

        //YIELD GOAL - check min and max.
        if (wizardYieldGoal <= 0) {
            setActiveStep(1);
            return;
        }
        if (wizardYieldGoal > 100000) {
            setActiveStep(1);
            return;
        }

        //Otherwise, okay, continue to next step.
        setActiveStep((prevActiveStep) => prevActiveStep + 1);

        //Are the steps complete?
        if (activeStep === steps.length - 1) {

            //Save this Crop Calculation to the history.
            // console.log('---- I am now appendBeagleCalculatorHistory');
            // console.log(wizardCropCalculation);
            // props.appendBeagleCalculatorHistory({history: [wizardCropCalculation]});

            //Is this a valid crop object?
            if (wizardCropCalculation.cropKey !== undefined) {
                props.appendBeagleCalculatorHistory(wizardCropCalculation);
            }

            //Reset the step count, and clear items.
            handleReset();
        }


        // console.log('---handleNext (bottom): wizardCropKey=' + wizardCropKey + " activeStep=" + activeStep);

    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
        setWizardCropKey('');
        setWizardYieldGoal('');
    };


    const labelButtonNew = labelCropStepper.labelButtonNew[langPref];
    const labelButtonBack = labelCropStepper.labelButtonBack[langPref];
    const labelButtonNext = labelCropStepper.labelButtonNext[langPref];
    const labelButtonFinished = labelCropStepper.labelButtonFinished[langPref];


    return (
        <div className={beagleStyles.root}>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            <div>
                {activeStep === steps.length ? (
                    <div>
                        <Typography className={beagleStyles.instructions} component={'span'}>All steps
                            completed</Typography>
                        <Button onClick={handleReset}>{labelButtonNew}</Button>
                    </div>
                ) : (
                    <div>
                        <Typography className={beagleStyles.instructions} component={'span'}>
                            {
                                getStepContent(
                                    props.beagleLanguagePreference,
                                    props.beagleMathPreference,
                                    activeStep,
                                    beagleCropDatabase,
                                    wizardCropKey,
                                    switchWizardCropKey,
                                    wizardYieldGoal,
                                    switchWizardYieldGoal,
                                    switchWizardCropCalculation,
                                    handleNext,
                                    beagleStyles)
                            }
                        </Typography>

                        <div className={beagleStyles.buttonVerticalSpacer}/>

                        <Button
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            className={beagleStyles.backButton}
                        >
                            {labelButtonBack}
                        </Button>

                        {
                            beagleCropDatabase.crops === undefined ?
                                (<Button variant="contained" color="primary" disabled>
                                    {labelButtonNext}
                                </Button>) :
                                (<Button variant="contained" color="primary" onClick={handleNext}>
                                    {activeStep === steps.length - 1 ? (labelButtonFinished) : (labelButtonNext)}
                                </Button>)
                        }


                    </div>
                )}
            </div>
        </div>
    );
}
